function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#lab-block-wrapper_svg__filter0_d)"
}, React.createElement("path", {
  fill: "#154268",
  d: "M7 7.306h216v122.293H7z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 72.274h119M16 79.917h119M16 87.56h119M16 56.987h119M16 64.63h119M88 47.433V98.07M112 47.433V98.07M64 47.433V98.07M40 47.433V98.07",
  stroke: "#5EB3EA",
  strokeWidth: 0.5
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 27.37V1.572h32M228.7 109.726v25.796h-32",
  stroke: "#039BE8",
  strokeWidth: 3
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#368FD5",
  strokeWidth: 0.5,
  d: "M16.25 49.594h118.5v45.36H16.25z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 26.414h197",
  stroke: "#5EB3EA"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M213 63.675h-91M213 77.05h-91M213 90.427h-91M213 103.802h-91M213 117.178h-91",
  stroke: "#039BE8",
  strokeWidth: 3,
  strokeDasharray: "3 16"
});

var _ref7 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 19.5,
  cy: 17.338,
  rx: 2.5,
  ry: 2.389,
  fill: "#0278C7"
});

var _ref8 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 29.5,
  cy: 17.338,
  rx: 2.5,
  ry: 2.389,
  fill: "#368FD5"
});

var _ref9 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 39.5,
  cy: 17.338,
  rx: 2.5,
  ry: 2.389,
  fill: "#5EB3EA"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#039BE8",
  stroke: "#039BE8",
  strokeWidth: 0.6,
  d: "M151.3 16.204h60.4v2.266h-60.4z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M64.446 111.751c-1.84-.509-3.404-1.787-4.125-3.601-1.237-3.108.47-6.611 3.81-7.824 3.342-1.214 7.053.323 8.29 3.431.748 1.883.417 3.911-.703 5.487",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M74.327 110.353c1.586-2.351 1.993-5.32.817-8.023-1.941-4.463-7.462-6.514-12.33-4.581-4.868 1.933-7.24 7.118-5.298 11.581 1.044 2.4 3.123 4.103 5.58 4.863",
  stroke: "#fff",
  strokeLinecap: "round"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M64.753 132.296l.139-27.837 21.265 18.805-7.496 1.422 4.381 9.476-6.836 2.885-4.38-9.477-7.073 4.726z",
  fill: "#154268",
  stroke: "#368FD5",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "lab-block-wrapper_svg__filter0_d",
  x: 3,
  y: 7.306,
  width: 224,
  height: 130.293,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.117647 0 0 0 0 0.333333 0 0 0 0 0.478431 0 0 0 0.15 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgLabBlockWrapper = function SvgLabBlockWrapper(props) {
  return React.createElement("svg", _extends({
    width: 231,
    height: 138,
    viewBox: "0 0 231 138",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

export default "data:image/svg+xml,%3Csvg width='231' height='138' viewBox='0 0 231 138' fill='none' xmlns='http://www.w3.org/2000/svg' %3E %3Cg filter='url(%23filter0_d)'%3E %3Crect x='7' y='7.30579' width='216' height='122.293' fill='%23154268' /%3E %3C/g%3E %3Cpath d='M16 72.2739H135' stroke='%235EB3EA' stroke-width='0.5' /%3E %3Cpath d='M16 79.9172H135' stroke='%235EB3EA' stroke-width='0.5' /%3E %3Cpath d='M16 87.5605H135' stroke='%235EB3EA' stroke-width='0.5' /%3E %3Cpath d='M16 56.9873H135' stroke='%235EB3EA' stroke-width='0.5' /%3E %3Cpath d='M16 64.6306H135' stroke='%235EB3EA' stroke-width='0.5' /%3E %3Cpath d='M88 47.4331L88 98.0701' stroke='%235EB3EA' stroke-width='0.5' /%3E %3Cpath d='M112 47.4331L112 98.0701' stroke='%235EB3EA' stroke-width='0.5' /%3E %3Cpath d='M64 47.4331L64 98.0701' stroke='%235EB3EA' stroke-width='0.5' /%3E %3Cpath d='M40 47.4331L40 98.0701' stroke='%235EB3EA' stroke-width='0.5' /%3E %3Cpath d='M2 27.3694L2 1.5732L34 1.57321' stroke='%23039BE8' stroke-width='3' /%3E %3Cpath d='M228.7 109.726V135.522H196.7' stroke='%23039BE8' stroke-width='3' /%3E %3Crect x='16.25' y='49.594' width='118.5' height='45.3599' stroke='%23368FD5' stroke-width='0.5' /%3E %3Cpath d='M16 26.4141L213 26.4141' stroke='%235EB3EA' /%3E %3Cpath d='M213 63.6752L122 63.6752' stroke='%23039BE8' stroke-width='3' stroke-dasharray='3 16' /%3E %3Cpath d='M213 77.0509L122 77.0509' stroke='%23039BE8' stroke-width='3' stroke-dasharray='3 16' /%3E %3Cpath d='M213 90.4268L122 90.4268' stroke='%23039BE8' stroke-width='3' stroke-dasharray='3 16' /%3E %3Cpath d='M213 103.802L122 103.802' stroke='%23039BE8' stroke-width='3' stroke-dasharray='3 16' /%3E %3Cpath d='M213 117.178L122 117.178' stroke='%23039BE8' stroke-width='3' stroke-dasharray='3 16' /%3E %3Cellipse cx='19.5' cy='17.3376' rx='2.5' ry='2.38854' fill='%230278C7' /%3E %3Cellipse cx='29.5' cy='17.3376' rx='2.5' ry='2.38854' fill='%23368FD5' /%3E %3Cellipse cx='39.5' cy='17.3376' rx='2.5' ry='2.38854' fill='%235EB3EA' /%3E %3Crect x='151.3' y='16.2044' width='60.4' height='2.26624' fill='%23039BE8' stroke='%23039BE8' stroke-width='0.6' /%3E %3Cpath d='M64.4464 111.751C62.6056 111.242 61.0422 109.964 60.3208 108.15C59.0844 105.042 60.7906 101.539 64.1318 100.326C67.4729 99.1123 71.1838 100.649 72.4203 103.757C73.1694 105.64 72.8384 107.668 71.7182 109.244' stroke='white' stroke-width='1.5' stroke-linecap='round' /%3E %3Cpath d='M74.3274 110.353C75.9134 108.002 76.3205 105.033 75.1442 102.33C73.2026 97.8665 67.6823 95.8155 62.8143 97.7487C57.9463 99.6818 55.574 104.867 57.5156 109.33C58.5598 111.73 60.639 113.433 63.0952 114.193' stroke='white' stroke-linecap='round' /%3E %3Cpath d='M64.7528 132.296L64.8916 104.459L86.1571 123.264L78.6614 124.686L83.0424 134.162L76.2062 137.047L71.8253 127.57L64.7528 132.296Z' fill='%23154268' stroke='%23368FD5' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cdefs%3E %3Cfilter id='filter0_d' x='3' y='7.30579' width='224' height='130.293' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB' %3E %3CfeFlood flood-opacity='0' result='BackgroundImageFix' /%3E %3CfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' /%3E %3CfeOffset dy='4' /%3E %3CfeGaussianBlur stdDeviation='2' /%3E %3CfeColorMatrix type='matrix' values='0 0 0 0 0.117647 0 0 0 0 0.333333 0 0 0 0 0.478431 0 0 0 0.15 0' /%3E %3CfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow' /%3E %3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape' /%3E %3C/filter%3E %3C/defs%3E %3C/svg%3E";
export { SvgLabBlockWrapper as ReactComponent };